import { UsaStates } from '../constants/enums';
import { usePaymentState } from '../components/Checkout/hooks/use-payment-state';

export function useCustomerGeoState() {
  const customerGeoState = usePaymentState((state) => state.customerGeoState);

  return { isCalifornia: customerGeoState?.toLowerCase() === UsaStates.CALIFORNIA };
}
